<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="device.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">IP-адрес устройства</label>
            <crm-input-text
              [(value)]="device.ipAddress"
              [isError]="$any(errors?.ipAddress)"></crm-input-text>
            <small
              *ngIf="errors?.ipAddress"
              class="p-error">
              {{ errors.ipAddress | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">UDP-порт подключения</label>
            <p-inputNumber [(ngModel)]="device.udpPort"> </p-inputNumber>
            <small
              *ngIf="errors?.udpPort"
              class="p-error">
              {{ errors.udpPort | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">Community-строка устройства</label>
            <crm-input-text
              [(value)]="device.barrierCommunity"
              [isError]="$any(errors?.barrierCommunity)"></crm-input-text>
            <small
              *ngIf="errors?.barrierCommunity"
              class="p-error">
              {{ errors.barrierCommunity | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">OID канала, по которому открывается шлагбаум</label>
            <crm-input-text
              [(value)]="device.barrierOpenRelayOid"
              [isError]="$any(errors?.barrierOpenRelayOid)"></crm-input-text>
            <small
              *ngIf="errors?.barrierOpenRelayOid"
              class="p-error">
              {{ errors.barrierOpenRelayOid | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Значение, которое надо отправить в канал для открытия шлагбаума</label>
            <p-inputNumber [(ngModel)]="device.barrierOpenRelayValue"> </p-inputNumber>
            <small
              *ngIf="errors?.barrierOpenRelayValue"
              class="p-error">
              {{ errors.barrierOpenRelayValue | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium required-field">OID канала, по которому считывается состояние шлагбаума</label>
            <crm-input-text
              [(value)]="device.barrierStatusRelayOid"
              [isError]="$any(errors?.barrierStatusRelayOid)"></crm-input-text>
            <small
              *ngIf="errors?.barrierStatusRelayOid"
              class="p-error">
              {{ errors.barrierStatusRelayOid | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Значение, при котором шлагбаум следует считать открытым</label>
            <p-inputNumber [(ngModel)]="device.barrierStatusRelayOpenValue"> </p-inputNumber>
            <small
              *ngIf="errors?.barrierStatusRelayOpenValue"
              class="p-error">
              {{ errors.barrierStatusRelayOpenValue | join }}
            </small>
          </div>

          <div class="field mt-3">
            <label class="font-medium">Помещение</label>
            <crm-room-single-select
              [(selectedRoom)]="device.room"
              [showClear]="true"
              appendTo="body"></crm-room-single-select>
            <small
              *ngIf="errors?.room"
              class="p-error">
              {{ errors.room | join }}
            </small>
          </div>

          <div class="field-checkbox mt-3">
            <p-checkbox
              [(ngModel)]="device.barrierOpenOnlyClosed"
              [binary]="true"
              inputId="controller"></p-checkbox>
            <label [for]="'controller'">Открывать только закрытый шлагбаум</label>
          </div>

          <ng-container *ngIf="device.barrierOpenOnlyClosed">
            <div class="field mt-3">
              <label class="font-medium">Интервал между попытками открыть шлагбаум в секундах</label>
              <p-inputNumber [(ngModel)]="device.barrierOpenAttemptDelay"> </p-inputNumber>
              <small
                *ngIf="errors?.barrierOpenAttemptDelay"
                class="p-error">
                {{ errors.barrierOpenAttemptDelay | join }}
              </small>
            </div>

            <div class="field mt-3">
              <label class="font-medium">Максимальное количество попыток открыть шлагбаум</label>
              <p-inputNumber [(ngModel)]="device.barrierOpenAttemptsCount"> </p-inputNumber>
              <small
                *ngIf="errors?.barrierOpenAttemptsCount"
                class="p-error">
                {{ errors.barrierOpenAttemptsCount | join }}
              </small>
            </div>
          </ng-container>
        </div>
      </p-card>
    </div>
  </div>

  <div
    class="mt-3"
    *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
    <crm-directory-common-history
      [entityName]="DirectoryCommonHistoryTypeEnum.NET_PING_DEVICE"
      [entityId]="formStoreService.getState.forms[this.index]?.entityId"
      [apiService]="netPingDeviceService">
    </crm-directory-common-history>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveDevice()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteDevice()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
